import api from "@/lib/api";
import { getSessionId } from "@/lib/track";
import { shouldPersistTracking } from "@/lib/consent";

const COOKIE = "lumiere_ad";
const SIXTY_DAYS = 60 * 24 * 60 * 60; // seconds

function setAdCookie(code) {
  try {
    document.cookie = `${COOKIE}=${encodeURIComponent(code)}; max-age=${SIXTY_DAYS}; path=/; SameSite=Lax`;
  } catch (e) {
    /* ignore */
  }
}

export function getAdRef() {
  try {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  } catch (e) {
    return null;
  }
}

/**
 * Detects a campaign tracking code in the URL (?ref=CODE), records the click
 * server-side, and — only if the visitor allows a durable identifier —
 * persists attribution in a 60-day cookie so a later order can be linked
 * back to the campaign.
 */
export function captureAdRef(search, pathname) {
  try {
    const params = new URLSearchParams(search || "");
    const code = params.get("ref");
    if (!code) return;
    if (shouldPersistTracking()) setAdCookie(code);
    api
      .post("/ad/click", {
        code,
        session_id: getSessionId(),
        ref: document.referrer || null,
        path: pathname || window.location.pathname,
      })
      .catch(() => {});
  } catch (e) {
    /* ignore */
  }
}
